<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙智能收银</div>
            <div class="banner_line"></div>
            <!-- <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div> -->
            <div class="banner_text">服务于有收银场景的实体门店，为门店提供收银营销一体化工具</div>
        </div>
        <img src="@/assets/Mobile/images/QcCashier/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">实体门店经营痛点</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCashier/programme1.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">多元商品管理</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcCashier/programme2.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">高效快捷的开单收银</div>
        </div>
        <div class="content" style="margin-top: 55px;">
            <img src="@/assets/Mobile/images/QcCashier/programme3.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">精细化的营销场景</div>
        </div>
        <div class="content" style="margin-top: 25px;">
            <img src="@/assets/Mobile/images/QcCashier/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">经营情况精准掌控</div>
        </div>
        <div class="content" style="margin-top: 26px;">
            <img src="@/assets/Mobile/images/QcCashier/programme5.png" alt="">
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">更多场景功能介绍</div>
        </div>
        <div class="content" style="margin-top: 23px;">
            <div class="content_box">
                <div class="sk-mobile-title">
                    <div class="title">AI识别提供更快、更便捷的收银方式</div>
                </div>
                <img style="margin-top: 46px;" src="@/assets/Mobile/images/QcCashier/programme6.png" alt="">
            </div>
            <div class="content_box">
                <div class="sk-mobile-title">
                    <div class="title">全面兼容，满足不同经营需求</div>
                    <div class="sub-title" style="padding: 0 9px;">开店所需的收银一体机、小票机、扫码枪、钱箱、打印机、摄像头等设备已为您全面兼容。蓝牙、LAN、USB接口、WIFI、移动数据网络、串口，满足所有业态的需求。</div>
                </div>
                <img style="margin-top: 23px;" src="@/assets/Mobile/images/QcCashier/programme7.png" alt="">
            </div>
            <div class="content_box1">
                <div class="sk-mobile-title">
                    <div class="title">深耕行业，提供更匹配行业的收银工具</div>
                </div>
                <div class="box_tool">
                    <div class="tool_top">
                        <div class="top_scroll">
                            <div :class="tooItem=='1'?'tool_item1':'tool_item'" @click="checkBg('1')">标准版</div>
                            <div :class="tooItem=='2'?'tool_item1':'tool_item'" @click="checkBg('2')">家电版</div>
                            <div :class="tooItem=='3'?'tool_item1':'tool_item'" @click="checkBg('3')">商超版</div>
                            <div :class="tooItem=='4'?'tool_item1':'tool_item'" @click="checkBg('4')">餐饮版</div>
                        </div>
                    </div>
                    <div class="tool_bottom">
                        <img v-if="tooItem=='1'" src="@/assets/Mobile/images/QcCashier/tool1.png" alt="">
                        <img v-if="tooItem=='2'" src="@/assets/Mobile/images/QcCashier/tool2.png" alt="">
                        <img v-if="tooItem=='3'" src="@/assets/Mobile/images/QcCashier/tool3.png" alt="">
                        <img v-if="tooItem=='4'" src="@/assets/Mobile/images/QcCashier/tool4.png" alt="">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">全场景一站式综合支付解决方案</div>
        </div>
        <div class="content" style="margin-top: 26px;">
            <img src="@/assets/Mobile/images/QcCashier/programme8.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcCashier/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcCashier/case2.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙智能收银" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙智能收银" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcCashier,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .content_box1{
    overflow: hidden;
    .box_tool{
        width:375px;
        display: flex;
        flex-direction: column;
        margin-top:12px;
        align-items: center;
        .tool_top{
            width:93%;
            height:33px;
            display: flex;
            flex-direction: row;
            overflow: scroll;
            .top_scroll{
                width:399px;
                display: flex;
                flex-direction: row;
                height:33px;
            }
            .tool_item{
                flex:1;
                height: 33px;
                background: #DFE9FF;
                border-radius: 5px;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 33px;
                margin-left: 3px;
            }
            .tool_item1{
                flex:1;
                height: 33px;
                background: #3986FF;
                border-radius: 5px;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 33px;
                margin-left: 3px;
            }
        }
        .tool_bottom{
            width:90%;
            img{
                width: 100%;
                height:100%;
            }
        }
    }
  }
  .content_box{
    background: #FFFFFF;
    margin-bottom:10px;
  }
  .content_btn{
    width: 100%;
    height: 35px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .btn_box{
        height: 33px;
        width: 110px;
    }
  }
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F3F8F8;
  }
  .programme3{
    background: #202239;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  